import { computed, getCurrentInstance } from "vue";

export const isSmAndDown = computed(() => {
	const instance = getCurrentInstance();
	return instance?.proxy?.$vuetify?.display?.smAndDown;
});
